import ky from "ky";
import RestEndpointsEnum from "../models/RestEndpointsEnum";
import { buildRestUrl } from "./RestService";
import { ProductionAuthContext } from "./ProductionService";
import { buildAuthHeadersForKy } from "./RestService";
import ISerialWorkflow from "../models/ISerialWorkflow";
import ISerialWorkflowStep from "../models/ISerialWorkflowStep";
import INewSerialWorkflowStep from "../models/INewSerialWorkflowStep";
import INewSerialWorkflow from "../models/INewSerialWorkflow";

function getHeaders(ctx: ProductionAuthContext): HeadersInit {
    return buildAuthHeadersForKy({
        userModel: ctx.userModel,
        supplierModel: ctx.supplierModel,
        vendorModel: ctx.vendorModel,
    });
}

export async function getSerialWorkflows(ctx: ProductionAuthContext): Promise<ISerialWorkflow[]> {
    const url = buildRestUrl({ endpoint: RestEndpointsEnum.ProductionWorkflows });
    return ky.get(url, { headers: getHeaders(ctx) }).json<ISerialWorkflow[]>();
}

export async function createSerialWorkflow(
    ctx: ProductionAuthContext,
    body: Omit<INewSerialWorkflow, "supplier_id">
): Promise<ISerialWorkflow> {
    const url = buildRestUrl({ endpoint: RestEndpointsEnum.ProductionWorkflows });
    return ky.post(url, { json: body, headers: getHeaders(ctx) }).json<ISerialWorkflow>();
}

export async function updateSerialWorkflow(
    ctx: ProductionAuthContext,
    workflowId: number,
    body: Partial<INewSerialWorkflow>
): Promise<ISerialWorkflow> {
    const url = buildRestUrl({
        endpoint: RestEndpointsEnum.ProductionWorkflow,
        params: { workflowId: String(workflowId) },
    });
    return ky.put(url, { json: body, headers: getHeaders(ctx) }).json<ISerialWorkflow>();
}

export async function createSerialWorkflowStep(
    ctx: ProductionAuthContext,
    workflowId: number,
    body: Omit<INewSerialWorkflowStep, "serial_workflow_id">
): Promise<ISerialWorkflowStep> {
    const url = buildRestUrl({
        endpoint: RestEndpointsEnum.ProductionWorkflowSteps,
        params: { workflowId: String(workflowId) },
    });
    return ky.post(url, { json: body, headers: getHeaders(ctx) }).json<ISerialWorkflowStep>();
}

export async function updateSerialWorkflowStep(
    ctx: ProductionAuthContext,
    stepId: number,
    body: Partial<INewSerialWorkflowStep>
): Promise<ISerialWorkflowStep> {
    const url = buildRestUrl({
        endpoint: RestEndpointsEnum.ProductionWorkflowStep,
        params: { stepId: String(stepId) },
    });
    return ky.put(url, { json: body, headers: getHeaders(ctx) }).json<ISerialWorkflowStep>();
}

export async function deleteSerialWorkflowStep(ctx: ProductionAuthContext, stepId: number): Promise<void> {
    const url = buildRestUrl({
        endpoint: RestEndpointsEnum.ProductionWorkflowStep,
        params: { stepId: String(stepId) },
    });
    await ky.delete(url, { headers: getHeaders(ctx) });
}

export async function reorderSerialWorkflowSteps(ctx: ProductionAuthContext, workflowId: number, stepIds: number[]): Promise<void> {
    const url = buildRestUrl({
        endpoint: RestEndpointsEnum.ProductionWorkflowSteps,
        params: { workflowId: String(workflowId) },
    });
    await ky.put(url, { json: { stepIds }, headers: getHeaders(ctx) });
}
